import script from "./ServiceDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./ServiceDetailComponent.vue?vue&type=style&index=0&id=202d6388&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-202d6388"]])

export default __exports__